// this is locked down to '*' !!!!
const key = process.env.GOOGLE_DEV_KEY || 'AIzaSyChQfBtgtHcEe2zY4mdvtcZxWMjheiACg4';
const Google = {};

export function googleInit() {
  const api = document.createElement('script');
  api.onload = () => {
    Google.maps = window.google.maps;
  };
  api.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
  document.body.appendChild(api);
}

export default Google;



// WEBPACK FOOTER //
// ./src/lib/google/index.js